import Image from './Viewer';

export default Image;
